<template>
  <div class="app-list-header level">
    <div class="level-left">
      <div
        v-if="sortableHeaders.length > 0 && hasOrderBy && viewBy === 'grid'"
        class="level-item order-by-container"
      >
        <span class="order-by-label">Order By</span>
        <div class="select order-by-select" :class="smallCss">
          <select v-model="orderByInternal">
            <option value="">None</option>
            <option
              v-for="(option, index) in sortableHeaders"
              :key="index"
              :value="index"
            >
              {{ option.orderByText || option.text }}
            </option>
          </select>
        </div>
      </div>
      <!-- DONT ERASE -->
      <!--div class="level-item">
        <button class="button is-secondary">
          <span class="icon icon-filter"></span>
          <span>Filter</span>
        </button>
      </div-->
      <div v-if="hasSearch" class="level-item">
        <search v-model="searchInternal" :is-small="isSmall" />
      </div>
    </div>

    <div class="level-right">
      <div v-if="hasViewAs" class="level-item">
        <div class="buttons has-addons">
          <button
            class="button is-secondary"
            :class="{
              'is-outlined': viewByInternal == 'list',
              'is-small': isSmall
            }"
            @click="viewByInternal = 'grid'"
          >
            <span class="icon icon-grid"></span>
          </button>
          <button
            class="button is-secondary"
            :class="{
              'is-outlined': viewByInternal == 'grid',
              'is-small': isSmall
            }"
            @click="viewByInternal = 'list'"
          >
            <span class="icon icon-list"></span>
          </button>
        </div>
      </div>
      <div v-if="hasCreate" class="level-item">
        <button class="button" @click="$emit('click:create')">
          <span class="icon-add"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search.vue';
import _ from 'lodash';

export default {
  name: 'AppDataViewHeader',
  components: { Search },
  props: {
    hasCreate: {
      type: Boolean,
      default: false
    },
    hasViewAs: {
      type: Boolean,
      default: true
    },
    hasSearch: {
      type: Boolean,
      default: true
    },
    hasOrderBy: {
      type: Boolean,
      default: true
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    viewBy: {
      type: String
      // required: true
    },
    orderBy: {
      type: Object,
      default: () => {}
      // required: true
    },
    search: {
      type: String,
      default: ''
      // required: true
    },
    headers: {
      type: Array
    },
    sort: {
      type: Array
    }
  },
  data() {
    return {
      viewByInternal: this.viewBy,
      searchInternal: '',
      sortIndex: ''
    };
  },
  computed: {
    orderByInternal: {
      get() {
        return this.sortIndex;
        //return Object.keys(this.orderBy)[0] || '';
      },
      set(value) {
        console.log('SET1 ', value);
        this.sortIndex = value;
        if (value >= 0) {
          //this.$emit('update:orderBy', { [value]: 1 });
          let column = this.sortableHeaders[value].value;
          let direction = this.sortableHeaders[value].sortDirection;
          if (direction == undefined) direction = 1;

          console.log('SET', column, direction);
          this.$emit('update:orderBy', { [column]: direction });
        } else {
          this.$emit('update:orderBy', {});
        }
      }
    },
    sortableHeaders() {
      return this.sort;
      //return _.filter(this.headers, { sortable: true });
    },
    smallCss() {
      if (this.isSmall) return 'is-small';
      else return '';
    }
  },
  watch: {
    searchInternal: {
      // immediate: true,
      handler(value) {
        this.$emit('update:search', value);
        this.debouncedSavePreferences();
      }
    },
    orderBy: {
      deep: true,
      handler(value) {
        this.debouncedSavePreferences();
      }
    },
    viewByInternal: {
      // immediate: true,
      handler(value) {
        this.$emit('update:viewBy', value);
        this.debouncedSavePreferences();
      }
    }
  },
  created() {
    this.debouncedSavePreferences = _.debounce(this.savePreference, 200);
  },
  mounted() {
    const config = this.$store.getters.preferences(this.$route.name);
    console.log('existe config', JSON.stringify(config, null, 2));

    if (config) {
      this.searchInternal = config.search;
      this.orderByInternal = config.order;
      this.viewByInternal = config.view;
    }
    // this.$emit('update:search', this.searchInternal);
    // this.$emit('update:orderBy', this.orderByInternal);
    // this.$emit('update:viewBy', this.viewByInternal);
  },
  methods: {
    savePreference() {
      this.$store.commit('setPreference', {
        name: this.$route.name,
        value: {
          search: this.searchInternal,
          order: this.orderByInternal,
          view: this.viewByInternal
        }
      });
    }
  }
};
</script>

<style lang="scss">
.app-list-header {
  .order-by-select {
    min-width: 100px;
  }
  .level-item {
    flex-grow: 0 !important;
  }
  .order-by-container {
    /*width: percentage(3/12);
    @include from($widescreen) {
      width: percentage(2/12);
    }*/
  }
  .order-by-label {
    white-space: nowrap;
    font-weight: 500;
    padding-right: $block-spacing * 2;
    // display: none;
    // @include from($widescreen) {
    //   display: inline;
    // }
  }
}
</style>
